import fb from '../images/socials/facebook_white.svg';
import ig from '../images/socials/instagram_white.svg';
import lin from '../images/socials/linkedin_white.svg';
import x from '../images/socials/twitter_white.svg';

export type FooterLink = {
  title: string;
  path: string;
};

export type SocialLink = {
  title: string;
  url: string;
  icon: string;
};

export const Company: FooterLink[] = [
  { title: 'Overview', path: '/' },
  { title: 'Team', path: '/team/' },
  { title: 'Career', path: '/careers/' },
  { title: 'Talk to Sales', path: '/request-a-demo/' },
  { title: 'Customer Support', path: '/contact/' },
  { title: 'Patents', path: '/patents/' },
];

export const Solutions: FooterLink[] = [
  {
    title: 'Assist platform',
    path: '/platform/',
  },
  {
    title: 'Stim Assist',
    path: '/stim-assist/',
  },
  {
    title: 'Embryo Assist',
    path: '/embryo-assist/',
  },
  {
    title: 'Success Predictor',
    path: '/success-predictor',
  },
];

export const Resources: FooterLink[] = [
  {
    title: 'Research',
    path: '/research/',
  },
  {
    title: 'Press & News',
    path: '/press/',
  },
];

export const Patients: FooterLink[] = [
  {
    title: 'Alife App',
    path: '/alife-app/',
  },
  {
    title: 'Blog',
    path: '/blog/',
  },
  {
    title: 'IVF Calculator',
    path: '/ivf-success-calculator/',
  },
];

export const Legal: FooterLink[] = [
  {
    title: 'Terms',
    path: '/terms-of-use/',
  },
  {
    title: 'Privacy',
    path: '/privacy/',
  },
  {
    title: 'App Privacy',
    path: '/privacy-alife-app/',
  },
  {
    title: 'Security',
    path: '/security/',
  },
  {
    title: 'Cookie Declaration',
    path: '/cookies/',
  },
];

export const Socials: SocialLink[] = [
  {
    title: 'Twitter',
    url: 'https://twitter.com/AlifeIVF',
    icon: x,
  },
  {
    title: 'Facebook',
    url: 'https://www.facebook.com/alifeivf',
    icon: fb,
  },
  {
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/company/alife-health/',
    icon: lin,
  },
  {
    title: 'Instagram',
    url: 'https://www.instagram.com/alifeivf/',
    icon: ig,
  },
];
